const commonAndMisc = {
  errorMessage404: "عفوا! الصفحة التي تبحث عنها غير موجودة", // translated 
  errorContentUnavailable:
    "عفوا! المحتوى الذي تبحث عنه غير موجود. يرجى الاتصال بنا بخصوص المشكلة", // translated 
  backToHome: "العودة إلى المنزل", // translated 
  information: "معلومة", // translated 
  additionalInformation: "معلومات إضافية", // translated 
  destinationPlaceholder: "اختر وجهتك", // translated 
  aboutUs: "معلومات عنا", // translated 
  pleaseWait: "انتظر من فضلك...", // translated 
  featuredHotels: "الفنادق المميزة", // translated 
  topPackages: "أعلى الحزم", // translated 
  topTours: "أعلى الجولات", // translated 
  traveller: "مسافر", // translated 
  reviews: "التعليقات", // translated 
  home: "بيت", // translated 
  packages: "الحزم", // translated 
  experiences: "خبرة", // translated 
  close: "يغلق", // translated 
  loadingMessage: "يرجى الانتظار بينما نبحث عن أفضل الأسعار المتاحة", // translated 
  loadingMessageTheHotelCo:
    "يرجى الانتظار بينما نبحث عن أفضل الأسعار المتاحة", // translated 
  loadingMessageSearchStrip:
    "يرجى الانتظار بينما نبحث عن أفضل الأسعار المتاحة...", // translated 
  topCountriesToVisit: "أفضل الدول للزيارة", // translated 
  profile: "حساب تعريفي", // translated 
  reservations: "التحفظات", // translated 
  myBookings: "حجوزاتي", // translated 
  address: "عنوان", // translated 
  firstName: "الاسم الأول", // translated 
  lastName: "اسم العائلة", // translated 
  email: "بريد إلكتروني", // translated 
  login: "تسجيل الدخول", // translated 
  logout: "تسجيل خروج", // translated 
  myProfile: "ملفي", // translated 
  myAccount: "حسابي", // translated 
  myPoints: "نقاطي", // translated 
  myQuotations: "اقتباساتي", // translated
  myChatRooms: "محادثاتي", // translated 
  chatRoomsListEmpty: "You have no chat rooms for this account.",
  chatRoomsOpen: "Open",
  chatRoomsLastActivity: "Last activity",
  chatRoomsUnread: "Unread",
  chatRoomsBadgeQuotation: "Quotation",
  chatRoomsBadgeTripOffer: "Trip offer",
  chatRoomsOpenQuotationAria: "Open quotation chat: {{name}}",
  chatRoomsOpenTripOfferAria: "Open trip offer chat: {{name}}",
  chatRoomsOpenGenericAria: "Open chat: {{name}}",
  quotationChatInvalidLink:
    "Invalid chat link. Open a chat from your profile or quotation list, or use exactly one of room_code or room_uid.",
  quotationChatNoTripDetails: "Trip details are not available for this chat.",
  chat: "Chat",
  verified: "تم التحقق", // translated 
  unverified: "لم يتم التحقق منها", // translated 
  selectLanguage: "اختار اللغة", // translated 
  selectCurrency: "اختر العملة", // translated 
  upgrade: "يرقي", // translated 
  membership: "عضوية", // translated 
  travelTrust: "ثقة السفر", // translated 
  signInUp: "تسجيل الدخول/أعلى", // translated 
  worldwideHotelsAndResortsAtAmazingWholesaleRates:
    "الفنادق والمنتجعات في جميع أنحاء العالم بأسعار الجملة مذهلة", // translated 
  dashboard: "لوحة القيادة", // translated 
  pricing: "التسعير", // translated 
  refundable: "مستردة", // translated 
  cars: "سيارات", // translated 
  cruises: "الرحلات البحرية", // translated 
  view: "منظر", // translated 
  price: "سعر", // translated 
  totalPrice: "السعر الكلي", // translated 
  filterRoomName: "اسم غرفة التصفية", // translated 
  get: "يحصل", // translated 
  guestInformationValidation: "التحقق من صحة معلومات الضيف", // translated 
  reservation: "حجز", // translated 
  checkIn: "تحقق في", // translated 
  checkOut: "الدفع", // translated 
  paymentInitiattionErroeMessage:
    "لم نتمكن من بدء عملية الدفع الخاصة بك. نحن نأسف للإزعاج", // translated 
  warning: "تحذير", // translated 
  couldNotFindPriceForDateWarning:
    "لم نتمكن من العثور على سعر لهذا التاريخ. يرجى المحاولة مرة أخرى لتاريخ مختلف", // translated 
  searchFormValidationError: "خطأ في التحقق من صحة نموذج البحث", // translated 
  pleaseSelectValidDateFirst: "الرجاء تحديد تاريخ صالح أولاً", // translated 
  searchError: "خطأ في البحث", // translated 
  priceSearchInitiationError:
    "لم نتمكن من بدء عملية البحث عن الأسعار. الرجاء معاودة المحاولة في وقت لاحق. نحن نأسف للإزعاج", // translated 
  searchWarning: "تحذير البحث", // translated 
  couldNotFindPriceAndOrAvailability:
    "لم نتمكن من العثور على السعر و/أو التوفر لطلبك. نحن نأسف للإزعاج", // translated 
  joinNow: " نضم الان", // translated 
  signIn: "تسجيل الدخول", // translated 
  searchNow: "ابحث الآن", // translated 
  bookingFailed: "فشل الحجز", // translated 
  sorryForTheInconvenience: "نحن نأسف للإزعاج", // translated 
  contactUsToAssistWithYourBooking:
    "يرجى الاتصال بنا للمساعدة في الحجز الخاص بك. نحن نأسف للإزعاج", // translated 
  paymentFailedTryAgain: "عملية الدفع فشلت. حاول مرة اخرى", // translated 
  quickLinks: "روابط سريعة", // translated 
  tours: "جولات", // translated 
  termsAndConditions: "الأحكام والشروط", // translated 
  pleaseWaitWhileInitiatingPayment:
    "يرجى الانتظار بينما نبدأ عملية الدفع الخاصة بك", // translated 
  back: "خلف", // translated 
  nextStep: "الخطوة التالية", // translated 
  book: "كتاب", // translated 
  checkout: "الدفع", // translated 
  specifyPickUpPoint: " حدد نقطة الالتقاط المفضلة لديك", // translated 
  pickupPoint: "نقطة الالتقاط", // translated 
  optional: "خياري", // translated 
  provideImportantInfoForYourTravel:
    "أخبرنا بأي معلومات قد تكون مهمة أثناء سفرك", // translated 
  remarks: "ملاحظات", // translated 
  travellerInformation: "معلومات المسافر", // translated 
  bookingRemarks: "ملاحظات الحجز", // translated 
  bookingOverview: "نظرة عامة على الحجز", // translated 
  paymentFailed: "عملية الدفع فشلت", // translated 
  paymentSuccess: "الدفع الناجح", // translated 
  at: "في", // At date // translated 
  on: "على", // on date // translated 
  person: "شخص", // translated 
  cancellationPolicy: "سياسة الإلغاء", // translated 
  From: "من", // translated 
  to: "إلى", // translated 
  cancellationIs: "الإلغاء هو", // translated 
  pickup: "يلتقط", // translated 
  flights: "الرحلات الجوية", // translated 
  Accommodation: "إقامة", // translated 
  payAndBook: "الدفع والحجز", // translated 
  onRequest: "تحت الطلب", // translated 
  weAreFindingTheBestAvailableServices:
    "نحن نجد أفضل الخدمات المتاحة", // translated 
  withTheBestAvailablePrices: "بأفضل الأسعار المتاحة", // translated 
  inRealTime: "في الوقت الحقيقي", // translated 
  seconds: "ثواني", // translated 
  thisProcessCanTakeUpToOneMinute: "يمكن أن تستغرق هذه العملية ما يصل إلى دقيقة واحدة", // translated 
  pleaseDoNotRefreshThisPage: "من فضلك لا تحديث هذه الصفحة", // translated 
  wellItSeemsItCanTakeBitLonger: "حسنًا...يبدو أن الأمر قد يستغرق وقتًا أطول قليلاً", // translated 
  yourBrowserDoesNotSupportTheVideoTag:
    "متصفحك الحالي لا يدعم تشغيل الفيديو", // translated 
  bookingSuccess: "نجاح الحجز", // translated 
  bookingReference: "معلومات الحجز", // translated 
  referenceCopied: "تم نسخ المرجع", // translated 
  shortlyYouReceiveEmailContainingInformationForYourReservation:
    "ستصلك قريبًا رسالة بريد إلكتروني تحتوي على جميع المعلومات المطلوبة للحجز الخاص بك", // translated 
  viewMore: "عرض المزيد", // translated 
  readMore: "اقرأ أكثر", // translated 
  customerSupport: "دعم العملاء", // translated 
  socialMedia: "وسائل التواصل الاجتماعي", // translated 
  hours: "ساعات", // translated 
  hour: "ساعة", // translated 
  minutes: "دقائق", // translated 
  minute: "دقيقة", // translated 
  memberId: "معرف العضو", // translated 
  star: "نجمة", // translated 
  stars: "النجوم", // translated 
  proceed: "يتابع", // translated 
  clearAllFilters: "مسح كافة عوامل التصفية", // translated 
  clearYourFilters: "يرجى مسح خيارات التصفية لعرض النتائج", // translated 
  noOptionsForSelectedFilters: "لا توجد خيارات متاحة لمطابقة المرشحات الخاصة بك", // translated 
  privacyPolicy: "سياسة الخصوصية", // translated 
  security: "حماية", // translated 
  nearby: "مجاور", // translated 
  distanceFromSelection: "المسافة من الاختيار", // translated 
  km: "كم", // translated 
  restaurants: "مطاعم", // translated 
  active: "نشيط", // translated 
  visitSite: "تفضل بزيارة الموقع", // translated 
  score: "نتيجة", // translated 
  applicationAvailable: "التطبيق متاح", // translated 
  sendUsEmail: "مراسلتنا على البريد الاليكتروني", // translated 
  sendUsYourRequest: "أرسل لنا طلبك", // translated 
  notAvailable: "غير متاح", // translated 
  found: "وجد", // translated 
  progressAt: "التقدم في", // translated 
  currency: "عملة", // translated 
  sendUsRequest: "أرسل لنا طلبك", // translated 
  noReservationsForThisProduct: "لا توجد تحفظات لهذا المنتج", // translated 
  noBookingsForThisProduct: "لا توجد حجوزات لهذا المنتج", // translated 
  confirmed: "مؤكد", // translated 
  cancelled: "ألغيت", // translated 
  pending: "قيد الانتظار", // translated 
  notConfirmed: "غير مؤكد", // translated 
  status: "حالة", // translated 
  reference: "مرجع", // translated 
  leadGuest: "الضيف الرئيسي", // translated 
  sendVoucherEmail: "إرسال قسيمة البريد الإلكتروني", // translated 
  sendCancellationEmail: "أرسل بريدًا إلكترونيًا للإلغاء", // translated 
  downloadVoucher: "تحميل قسيمة", // translated 
  emailHasBeenSent: "البريد الإلكتروني المرسلة بنجاح", // translated 
  emailNotSentTryAgain: "لم يتم إرسال البريد الإلكتروني! حاول مرة اخرى", // translated 
  titleIsRequired: "العنوان مطلوب", // translated 
  genderIsRequired: "الجنس مطلوب", // translated 
  firstNameMustContainAlphabetic:
    "يجب أن يحتوي الاسم الأول على أحرف أبجدية فقط", // translated 
  firstNameIsRequired: "الإسم الأول مطلوب", // translated 
  lastNameIsRequired: "إسم العائلة مطلوب", // translated 
  lastNameMustContainAlphabetic:
    "يجب أن يحتوي الاسم الأخير على أحرف أبجدية فقط", // translated 
  phoneNumberInTheFormat: "يجب أن يكون رقم الهاتف بالتنسيق بدون مسافات", // translated 
  phoneNumberIsRequired: "رقم الهاتف مطلوب", // translated 
  emailIsRequired: "البريد الالكتروني مطلوب", // translated 
  invalidEmail: "بريد إلكتروني خاطئ", // translated 
  addressIsRequired: "العنوان مطلوب", // translated 
  cityIsRequired: "المدينة مطلوبة", // translated 
  postalCodeIsRequired: "الرمز البريدي مطلوب", // translated 
  countryIsRequired: "الدولة مطلوبة", // translated 
  yourReservationIsInProgress: "حجزك قيد التقدم", // translated 
  yourReservationHasBeenRegistered: "لقد تم تسجيل الحجز الخاص بك", // translated 
  clickHere: "انقر هنا", // translated 
  iHaveReadAgreeWithAbove: "لقد قرأت وأوافق على ما ورد أعلاه", // translated 
  pleaseCheckTheBox:
    "يرجى تحديد المربع الموجود بالأسفل للإشارة إلى أنك قرأت المعلومات المقدمة ووافقت عليها قبل المتابعة إلى الخطوة التالية.", // translated 
  pleaseAcceptProperty:
    "يرجى تحديد المربع الموجود في الأعلى للإشارة إلى أن العقار الذي يتم حجزه هو العقار الذي تحتاجه.", // translated 
  ourContactNumbersAre: "أرقام الاتصال لدينا هي", // translated 
  operationalHours: "ساعات العمل", // translated 
  monday: "الاثنين", // translated 
  tuesday: "يوم الثلاثاء", // translated 
  wednesday: "الأربعاء", // translated 
  thursday: "يوم الخميس", // translated 
  friday: "جمعة", // translated 
  saturday: "السبت", // translated 
  sunday: "الأحد", // translated 
  monday_to_friday: "من الإثنين إلى الجمعة", // translated 
  closed: "مغلق", // translated 
  topUpPoints: "نقاط التعبئة", // translated 
  gender: "جنس", // translated 
  nationality: "جنسية", // translated 
  maintenanceTitle: "الموقع قيد الصيانة",
  maintenanceDescription: "نجري صيانة مجدولة. يرجى العودة قريبًا.",
  maintenanceCountdownLabel: "الوقت المتبقي المقدر",
  maintenanceLogoAlt: "شعار الموقع",
  maintenanceDays: "أيام",
  maintenanceHours: "ساعات",
  maintenanceMinutes: "دقائق",
  maintenanceSeconds: "ثوانٍ",
  maintenanceStatusBadge: "صيانة مجدولة",
  maintenanceRefresh: "تحديث الصفحة",
  maintenanceExpired: "ينبغي أن تكتمل الصيانة قريبًا. يرجى تحديث الصفحة.",
};



export default commonAndMisc;
